<div class="inner-content">
  <ion-list mode="ios" lines="none" class="list-modal">
    <ion-item
      lines="none"
      mode="md"
      color="white"
      [attr.data-test]="'Automation.txt-profile-modal-confirm-texto' | translate"
      class="ion-text-center"
    >
      <ion-label mode="md" color="getm-neutral-dark" class="modal-text">
        <ng-container *ngIf="ModalConfirm.text">
          <p [innerHTML]="ModalConfirm.text | htmlSeguro" class="title"></p>
        </ng-container>
        <ng-container *ngIf="ModalConfirm.text && ModalConfirm.subText">
          <br />
        </ng-container>
        <ng-container *ngIf="ModalConfirm.subText">
          <p
            [innerHTML]="ModalConfirm.subText | htmlSeguro"
            class="subText"
          ></p>
        </ng-container>
      </ion-label>
    </ion-item>

    <ion-item lines="none" mode="md" color="white">
      <ng-container *ngIf="ModalConfirm.buttomLeft">
        <getm-button
          class="button-expand-default"
          [attr.data-test]="'Automation.btn-profile-modal-confirm-accept' | translate"
          [text]="ModalConfirm.buttomLeft.text"
          [color]="ModalConfirm.buttomRight === null ? 'primary' : 'tertiary'"
          expand="block"
          [ngClass]="ModalConfirm.buttomLeft.class"
          (btnClick)="onConfirm(true)"
        ></getm-button>
      </ng-container>

      <ng-container *ngIf="ModalConfirm.buttomRight">
        <getm-button
          class="button-expand-default"
          [text]="ModalConfirm.buttomRight.text"
          color="primary"
          expand="block"
          [ngClass]="ModalConfirm.buttomRight.class"
          (btnClick)="onConfirm(false)"
        ></getm-button>
      </ng-container>
    </ion-item>

    <ng-container *ngIf="ModalConfirm.textFooter">
      <ion-item
        lines="none"
        mode="md"
        color="white"
        class="ion-text-center item-textFooter"
      >
        <ion-label mode="md" color="cadet-grey" class="textFooter">
          {{ ModalConfirm.textFooter }}
        </ion-label>
      </ion-item>
    </ng-container>
  </ion-list>
</div>
